import React, { Component, useState } from 'react';
import PropTypes from 'prop-types';
import { inject, observer } from 'mobx-react';
import clsx from 'clsx';
import { MenuItem, Select, TextField } from '@material-ui/core';
import { withRouter } from 'react-router-dom';
import "../../Styles/react-datepicker.css";
import Loader from 'react-loader-spinner';
import { withStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';
import Checkbox from '@material-ui/core/Checkbox';
import Input from '@material-ui/core/Input';
import FormControl from '@material-ui/core/FormControl';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
import InputLabel from '@material-ui/core/InputLabel';
import Autocomplete, { createFilterOptions } from '@material-ui/lab/Autocomplete';
const filter = createFilterOptions();



const fields = [
    {
        name: 'name',
        label: 'First Name',
        required: true,
        placeholder: 'e.g.  John, Alicia'
    },
    {
        name: 'lastName',
        label: 'Last Name',
        required: true,
    },
]

const fields1 = [
    {
        name: 'emailId',
        label: 'Business Email ID',
        required: true,
    },
    {
        name: 'phone',
        label: 'Contact Number',
        required: true,
    },
]

const newFields = [
    {
        name: 'emailId',
        label: 'Business Email ID',
        required: true,
    },
    {
        name: 'phone',
        label: 'Phone Number *',
        required: true,
    }
]

const fields2 = [
    {
        name: 'company',
        label: 'Company Name',
        required: true,
    },
    {
        name: 'jobTitle',
        label: 'Job Title',
        required: false,
    }
]


const fields3 = [
    {
        name: 'region',
        label: 'Region *',
        required: true,
    },
    {
        name: 'industry',
        label: 'Industry *',
        required: true,
    }
]



const fields4 = [
    {
        name: 'useCase',
        label: 'Use Case',
        required: false,
        placeholder: 'e.g. Invoice Processing, Customer Onboarding'
    }
]

const regions = ['US', 'Europe', 'India', 'Middle East', 'Africa']
const industries = ['Automobile', 'Banking', 'Financial Services', 'Insurance', 'Travel & Hospitality', 'Telecommunications',
    'Non-Profit Organisation', 'Public Sector', 'Healthcare & Life Sciences', 'Legal', 'Logistics & Transportation', 'Manufacturing', 'Real Estate', 'Retail & E-commerce', 'Others'
]
const useCases = [
    'Customer Onboarding',
    'Account Opening & Maintenance',
    'Bill of Lading Processing',
    'Signature Verification',
    'Data Compliance',
    'Application Processing',
    'Insurance Claims Processing or Underwriting',
    'Invoice Processing',
    'Mortgage Processing ',
    'Mailroom Automation',
    'Order to Cash',
    'Procure to Pay',
    'Risk Verification',
    'Identity Verification',
    'Medical Records',
    'Patient onboarding', 'Clinical Trial Records',
    'Others'
]
const maxTime = 7
@inject('commonStore') @observer
@observer
class TrialForm extends Component {
    state = {
        info: { privacy: false, lastName: '', useCase: '', phoneNumber: '09983', jobTitle: '' },
        validationErrors: {},
        inProgress: false,
        emailIds: [],
        showConfirmation: false,
        additionalEmail: '',
        openRegionMenu: false,
        openIndustryMenu: false,
        openUseCaseMenu: false,
        otpRequested: false,
        otpRequestedOnce: false
    }

    componentDidMount() {
        if (window.local_Storage.getItem('locationInfo')) {
            if (JSON.parse(window.local_Storage.getItem('locationInfo')).hasOwnProperty('ip'))
                console.log('Location Set')
            else
                this.props.commonStore.getLocationInfo()
        }
        else {
            this.props.commonStore.getLocationInfo()
        }


    }

    validateFields = () => {

        const { validationErrors, info, emailIds, otpRequestedOnce } = this.state;
        let otpRegex = /^[0-9]{1,6}$/
        let valid = true
        if (!info.name || (info.name && info.name.trim().length < 2)) {
            validationErrors.name = 'Please enter a valid first name'
            this.setState({ validationErrors });
            valid = false;
        }
        else
            delete validationErrors.name
        if (!info.lastName || (info.lastName && info.lastName.trim().length < 2)) {
            validationErrors.lastName = 'Please enter a valid last name'
            this.setState({ validationErrors });
            valid = false;
        }
        else
            delete validationErrors.lastName
        if (!info.phone || (info.phone && info.phone.trim().length < 12 && info.phone.startsWith("91")) || (info.phone && info.phone.trim().length < 8 && !info.phone.startsWith("91"))) {
            validationErrors.phone = 'Please enter a valid phone number'
            this.setState({ validationErrors });
            valid = false;
        }
        else
            delete validationErrors.phone
        if (!info.emailId || !this.props.commonStore.validateEmail(info.emailId)) {
            validationErrors.emailId = 'Please enter a valid Business Email ID'
            this.setState({ validationErrors });
            valid = false;
        }
        else
            delete validationErrors.emailId
        if (!info.company || !this.props.commonStore.validateText(info.company)) {
            validationErrors.company = 'Please enter a valid company name'
            this.setState({ validationErrors });
            valid = false;
        }
        else
            delete validationErrors.company
        if (!otpRequestedOnce) {
            console.log('here')
            validationErrors.otp = 'Please request OTP to verify your Email'
            this.setState({ validationErrors });
            valid = false;
        }
        else if (otpRequestedOnce && !otpRegex.test(info.otp)) {
            validationErrors.otp = 'Please enter a valid 6 digit OTP'
            this.setState({ validationErrors });
            valid = false;
        }
        else
            delete validationErrors.otp

        /* if (!info.useCase || !this.props.commonStore.validateText(info.useCase)) {
             validationErrors.useCase = 'Please enter a Use Case'
             this.setState({ validationErrors });
             valid = false;
         }
         else
             delete validationErrors.useCase*/

        if (valid) {
            this.setState({
                validationErrors: {}
            });
        }
        return valid;
    }

    bookSlot = () => {
        let valid = false
        valid = this.validateFields()
        if (valid) {
            if (this.state.info.privacy) {
                this.setState({ inProgress: true })
                this.props.commonStore.registerForTrial(this.state.info)
                    .then((data) => {
                        if (data && data.success) {
                            window.gtag_report_conversion()
                            this.setState({ inProgress: false })
                            if (!this.props.commonStore.inProgress && !this.props.commonStore.error)
                                this.props.history.push({
                                    pathname: `/visionera/successfulRegistration`
                                })
                        }
                    })
            }
            else if (!this.state.info.privacy) {
                this.props.commonStore.handleOpenSnackBar('Please accept the terms of use before proceeding', 'info')
            }
        }
        else if (!this.state.info.privacy) {
            this.props.commonStore.handleOpenSnackBar('Please accept the terms of use before proceeding', 'info')
        }
    }

    constructor() {
        super()
        this.chipInputRef = React.createRef()
    }

    handleChange = (event, field, value) => {
        if (field !== 'phone')
            event.stopPropagation()
        const info = Object.assign({}, this.state.info, {
            [field]: value
        });
        this.setState({ info });
    }

    onClickRequestOtp = () => {
        const { info, validationErrors } = this.state
        delete validationErrors.otp
        this.setState({ validationErrors });
        if (!info.emailId || !this.props.commonStore.validateEmail(info.emailId)) {
            this.props.commonStore.handleOpenSnackBar('Please enter a valid business Email ID', 'error')
            return
        }
        this.props.commonStore.requestOtp(info.emailId)
            .then((res) => {
                if (res && res.success)
                    this.setState({ otpRequested: true, otpRequestedOnce: true })
            })
    }

    resetOtpRequested = () => {
        this.setState({ otpRequested: false })
    }

    render() {
        const { classes } = this.props
        const { info, validationErrors, inProgress, emailIds, openRegionMenu, openIndustryMenu, openUseCaseMenu } = this.state;
        return (
            <div className='sc-container1 t-container'>
                <img style={{ width: '15%' }} src="https://amygb-web-static.s3.ap-south-1.amazonaws.com/visionLogo.png"></img>
                <div className='subHeading2 bold rowFlex' style={{ justifyContent: 'space-between' }}>
                    <div className='vertCenter' style={{ flex: '1' }} id='meetingConfirmation' style={{ paddingTop: '4%' }}>Start your 7-day free trial</div>
                    <div className='rowFlex formButtonContainer demo-formButtonContainer' >
                        {/* <div className={'buttonText contact-submitButton contact-cancelButton vertCenter'} onClick={(e) => this.props.history.push('/selectDate')}>
                            GO BACK
                        </div>*/}


                    </div>

                </div>
                <div className='rowFlex'>
                    <div className='checkMark xs-desc bold'>
                        <CheckCircleIcon style={{
                            transform: "scale(0.7)",
                            color: '#04b071'
                        }} />
                        <div className='colFlex flexCenter'>No credit card required</div>
                    </div>
                    {<div className='checkMark xs-desc bold'>
                        <CheckCircleIcon style={{
                            transform: "scale(0.7)",
                            color: '#04b071'
                        }} />
                        <div className='colFlex flexCenter'>No software to install</div>
                    </div>}
                </div>
                <div className={'contact-formContainer'} id='trialForm'>

                    <div className='form-row'>
                        {fields.map((row, index) => (
                            <div key={'field' + index} className={clsx({ ['contact-inputContainer']: true, ['cs-inputContainer']: true })}>
                                <div style={{ display: 'flex', justifyContent: index === 0 ? 'flex-start' : 'flex-end', width: '100%' }}>
                                    <div className='contact-textFieldContainer' style={{ justifyContent: index === 0 ? 'flex-start' : 'flex-end' }}>
                                        <TextField variant="outlined" key={info[`${row}`]} id={row.label} required={true} label={row.label} className={clsx({ ['desc']: true, ['contact-textField']: true, })} classes={{ root: 'contact-textField' }} required={true}
                                            value={info[`${row}`]} onChange={(e) => this.handleChange(e, row.name, e.target.value)} style={{ width: '98%' }} InputLabelProps={{ classes: { root: 'tLabel' } }} placeholder={row.placeholder}
                                        />
                                        {validationErrors[row.name] ? <div className='s-desc contact-errorMsg'>{validationErrors[row.name]}</div> : null}
                                    </div>
                                </div>
                            </div>
                        ))}

                    </div>
                    <div className='form-row'>
                        {fields1.map((row, index) => (

                            index === 0 ?
                                <div key={'field' + index} className={clsx({ ['contact-inputContainer']: true, ['cs-inputContainer']: true })}>
                                    <div style={{ display: 'flex', justifyContent: index === 0 ? 'flex-start' : 'flex-end', width: '100%' }}>
                                        <div className='contact-textFieldContainer' style={{ justifyContent: index === 0 ? 'flex-start' : 'flex-end' }}>
                                            <TextField variant="outlined" key={info[`${row}`]} id={row.label} required={true} label={row.label} className={clsx({ ['desc']: true, ['contact-textField']: true, })} classes={{ root: 'contact-textField' }} required={true}
                                                value={info[`${row}`]} onChange={(e) => this.handleChange(e, row.name, e.target.value)} style={{ width: '98%' }} InputLabelProps={{ classes: { root: 'tLabel' } }} placeholder={row.placeholder}
                                            />
                                            {validationErrors[row.name] ? <div className='s-desc contact-errorMsg'>{validationErrors[row.name]}</div> : null}
                                        </div>
                                    </div>
                                </div>
                                :
                                <div key={'field' + index} className={clsx({ ['contact-inputContainer']: true, ['cs-inputContainer']: true })}>
                                    <div style={{ display: 'flex', justifyContent: index === 0 ? 'flex-start' : 'flex-end', width: '100%' }}>
                                        <div className='contact-textFieldContainer' style={{ justifyContent: index === 0 ? 'flex-start' : 'flex-end' }}>

                                            <PhoneInput
                                                country={'in'}
                                                placeholder='Phone Number'
                                                value={info[`${row}`]} onChange={(e) => this.handleChange(e, row.name, e)}
                                            />
                                            {validationErrors[row.name] ? <div className='s-desc contact-errorMsg'>{validationErrors[row.name]}</div> : null}
                                        </div>
                                    </div>
                                </div>
                        ))}

                    </div>

                    <div className='form-row'>
                        {fields2.map((row, index) => (
                            <div key={'field' + index} className={clsx({ ['contact-inputContainer']: true, ['cs-inputContainer']: true })}>
                                <div style={{ display: 'flex', justifyContent: index === 0 ? 'flex-start' : 'flex-end', width: '100%' }}>
                                    <div className='contact-textFieldContainer' style={{ justifyContent: index === 0 ? 'flex-start' : 'flex-end' }}>
                                        <TextField variant="outlined" required={row.required} label={row.label} className={clsx({ ['desc']: true, ['contact-textField']: true, })} classes={{ root: 'contact-textField' }}
                                            value={info[`${row}`]} onChange={(e) => this.handleChange(e, row.name, e.target.value)} style={{ width: '98%' }}
                                        />
                                        {validationErrors[row.name] ? <div className='s-desc contact-errorMsg'>{validationErrors[row.name]}</div> : null}
                                    </div>
                                </div>
                            </div>
                        ))}

                    </div>
                    <div className='form-row'>
                        {fields4.map((row, index) => (
                            <div key={'field' + index} className={clsx({ ['contact-inputContainer']: true, ['cs-inputContainer']: true })}>
                                <div style={{ display: 'flex', justifyContent: index === 0 ? 'flex-start' : 'flex-end', width: '100%' }}>
                                    <div className='contact-textFieldContainer' style={{ justifyContent: index === 0 ? 'flex-start' : 'flex-end', width: '99%' }}>
                                        <TextField variant="outlined" key={info[`${row}`]} id={row.label} label={row.label} className={clsx({ ['desc']: true, ['contact-textField']: true, })} classes={{ root: 'contact-textField' }} required={row.required}
                                            value={info[`${row}`]} onChange={(e) => this.handleChange(e, row.name, e.target.value)} style={{ width: '100%' }} InputLabelProps={{ classes: { root: 'tLabel' } }} placeholder={row.placeholder}
                                        />
                                        {validationErrors[row.name] ? <div className='s-desc contact-errorMsg'>{validationErrors[row.name]}</div> : null}
                                    </div>
                                </div>
                            </div>
                        ))}

                    </div>
                    <div className='form-row'>
                        <div className={clsx({ ['contact-inputContainer']: true, ['cs-inputContainer']: true })}>
                            <div style={{ display: 'flex', justifyContent: 'flex-start', width: '100%' }}>
                                <div className='contact-textFieldContainer' style={{ justifyContent: 'flex-start', width: '98%' }}>
                                    <TextField variant="outlined" label={'OTP'} className={clsx({ ['desc']: true, ['contact-textField']: true, })} classes={{ root: 'contact-textField' }} required={true}
                                        value={info.otp} onChange={(e) => this.handleChange(e, 'otp', e.target.value)} style={{ width: '98%' }} InputLabelProps={{ classes: { root: 'tLabel' } }} placeholder={'Enter OTP sent on your Email'}
                                    />
                                    {validationErrors.otp ? <div className='s-desc contact-errorMsg'>{validationErrors.otp}</div> : null}
                                </div>
                            </div>
                        </div>
                        <div className={clsx({ ['contact-inputContainer']: true, ['cs-inputContainer']: true })}>
                            {/*<div style={{ display: 'flex', justifyContent: 'flex-end', width: '100%' }}>
                                <div className='contact-textFieldContainer' style={{ justifyContent: 'flex-end' , width: '98%' }}>
                                    <TextField variant="outlined" key={info.otp} id={'OTP'} label={'OTP'} className={clsx({ ['desc']: true, ['contact-textField']: true, })} classes={{ root: 'contact-textField' }} required={true}
                                        value={info.otp} onChange={(e) => this.handleChange(e, 'otp', e.target.value)} style={{ justifyContent: 'flex-end',width: '98%' }} InputLabelProps={{ classes: { root: 'tLabel' } }} placeholder={'Enter OTP sent on your Email'}
                                    />
                                    {validationErrors.otp ? <div className='s-desc contact-errorMsg'>{validationErrors.otp}</div> : null}
                                </div>
                            </div>*/}
                            <div className='cursor underLine s-desc colFlex flexCenter' onClick={this.state.otpRequested ? undefined : this.onClickRequestOtp} style={{ height: 'calc(100% - 2vh)', color: this.state.otpRequested ? 'gray' : 'black' }}>
                                <div> {this.state.otpRequested ?
                                    <div className='rowFlex'>{'Resend OTP in '}&nbsp; <CountdownTimer timeStart={30} resetOtpRequested={this.resetOtpRequested} /></div> :
                                    (this.props.commonStore.requestProgress ? <Loader color="black" width="10" height="10" type="ThreeDots" /> : 'Request OTP On Email.')
                                }
                                </div>
                            </div>


                        </div>

                    </div>



                    <div key={'fieldProduct'} className={clsx({ ['contact-inputContainer']: true, ['cs-inputContainer']: true })} style={{ marginBottom: '1vh' }}>


                        <div className={'disclaimer xs-desc'}>
                            <Checkbox style={{
                                transform: "scale(0.7)",
                            }} checked={info.privacy} onChange={(e) => this.handleChange(e, 'privacy', e.target.checked)} />
                            <div className='colFlex flexCenter'><div >By submitting this form, you agree to VisionERA's terms of use and&nbsp;<a target="_blank" href='https://www.amygb.ai/privacy-policy/'>privacy policy</a>.</div></div>
                        </div>

                        {/*<div className='disclaimer s-desc'>
                            <div className='colFlex flexCenter'><div className='rowFlex'>VisionEra may keep me informed with emails about product information and latest releases</div></div>
                        </div>*/}
                        <br />
                        <div key={this.props.commonStore.inProgress} className={'buttonText contact-submitButton vertCenter semiBold'} onClick={this.bookSlot} style={{ padding: '1vh 2vw' }}>
                            {
                                this.props.commonStore.inProgress ?
                                    <Loader color="white" width="10" height="10" type="ThreeDots" /> : 'START MY FREE TRIAL'
                            }
                            <img height="1" width="1" style={{ display: 'none' }} alt="" src="https://px.ads.linkedin.com/collect/?pid=3394058&conversionId=4922794&fmt=gif" />
                        </div>

                    </div>



                    {/* <div className='contact-textFieldContainer' style={{ width: '100%' }}>
                                                <TextField variant="outlined" className={clsx({ ['desc']: true, ['contact-textField']: true,   })} style={{ width: '100%' }} classes={{ root: 'contact-textField' }} required={true}
                                                    placeholder={'WRITE YOUR MESSAGE HERE...'} multiline={true} rowsMax={7} rows={7} value={info.message} onChange={(e) => this.handleChange(e, 'message', e.target.value)}
                                                />
                                                {validationErrors.message ? <div className='s-desc contact-errorMsg'>{validationErrors.message}</div> : null}
                                            </div>*/}


                </div>
            </div>
        )
    }
}
TrialForm.propTypes = {
    classes: PropTypes.object.isRequired,
};
export default withRouter(TrialForm);


function CountdownTimer({ timeStart, resetOtpRequested }) {
    const [counter, setCounter] = React.useState(timeStart);

    // Third Attempts
    React.useEffect(() => {
        const timer =
            counter > 0 && setInterval(() => setCounter(counter - 1), 1000);
        if (counter === 0)
            resetOtpRequested()
        return () => clearInterval(timer);

    }, [counter]);

    return (
        counter === 0 ? null :
            <div className="App">
                <div className='s-desc'>{counter}s</div>
            </div>
    );
}

